import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/payment";
import {PaymentElementView} from "./payment_element";

export class PaymentView extends View {

    private readonly server = Server.instance();

    static classname = "payment-view";

    private paymentElementView = new PaymentElementView();

    constructor() {
        super(PaymentView.classname);
    }

    refresh() {
        this.update();
        this.paymentElementView.refresh();
    }

    createIntent() {

        const valid = this.elt().find("form.with-validation").valid();
        if (! valid) {
            return;
        }

        const amt = this.elt().find("input[name='amount']").val();
        if (! amt) {
            return;
        }
        let dollars = Number.parseFloat(amt as string);
        this.elt().find("input[name='amount']").val(dollars);
        const cents = parseInt("" + (dollars * 100));
        dollars = cents / 100;

        const description = this.elt().find("input[name='description']").val() as string || undefined;

        this.paymentElementView.createIntent(dollars, description);
        this.elt().find(".amount-form").hide();

    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            paymentElementView: this.paymentElementView
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                "amount": {
                    "required": true,
                    "number": true
                }
            }
        });

        return out;
    }

}

View.on(
    "." + PaymentView.classname,
    "submit",
    ".amount-form",
    function(that: PaymentView, event, elt) {
        event.preventDefault();
        that.createIntent();
    });

View.on(
    "." + PaymentView.classname,
    "click",
    ".refresh",
    function(that: PaymentView, event, elt) {
        event.preventDefault();
        that.refresh();
    });



